<template>
	<div id="app">
		<NavBar/>
		<CarouselSlide/>
		<b-container fluid class="bv-example-row px-0" id="sell-project">
			<b-row class="align-items-center proyect-elements" no-gutters v-for="(project, key) in projects" v-bind:key="key">
				<b-col lg="8" data-aos="fade-down" data-aos-offset="200" :order-lg="(project.left_right ? '1' : '2')">
					<img  class="d-block img-fluid w-100 img-project cursor-pointer" :src="project.image_url" alt="image">
				</b-col>
				<b-col lg="4" class="text-left p-4" data-aos="fade-up"  data-aos-offset="200" :order-lg="(project.left_right ? '2' : '1')">
					<h2 class="subtitle-type">{{project.project_type}}</h2>
					<h1 class="subtitle">{{project.name}}</h1>
					<span class="subtitle-location">{{project.place}}</span>
					<br>
					<a v-if="project.link" :href="project.link" target="_blank" class="btn btn-br text-uppercase my-2">Ver proyecto</a>
					<a v-else-if="project.url2" :href="project.url2" class="btn btn-br text-uppercase my-2">Ver proyecto</a>
					<a v-else @click="goTo('project', { project_id: project.url })" class="btn btn-br text-uppercase my-2">Ver proyecto</a>
					<ExecutiveAvatar v-if="project.executive" :executive="project.executive" class="mt-2" />
					<ExecutiveAvatar v-if="project.second_executive" :executive="project.second_executive" class="mt-2" />
				</b-col>
			</b-row>
			<b-modal id="modal-lightbox-home" size="lg" centered hide-header hide-footer body-bg-variant="transparent" content-class="border-0 bg-transparent"  v-if="this.lightbox">						
				<b-img :src="this.src" fluid center v-if="this.link_" @click="openLink(link_)"></b-img>			
				<b-img :src="this.src" fluid center v-else @click="$bvModal.hide('modal-lightbox-home')"></b-img>			
			</b-modal>
		</b-container>		
		
	</div>
</template>

<script>
	import CarouselSlide from '../../../components/CarouselSlide.vue';
	import NavBar from '../../../components/NavBar.vue';
	import ExecutiveAvatar from '../../../components/ExecutiveAvatar.vue';
	export default {		
		name: 'page',
		components: {
			CarouselSlide, NavBar, ExecutiveAvatar
		},
		props: {
			scrollTo: {default: null}
		},
		mounted() {
			this.$store.commit('setProjects');

			this.$root.captureUtm();
			this.$root.sessionStorageSet('utm_dhunter','inmobiliariabi');
			this.$store.state.popup = false;
			
			if(document.getElementById('tidio-chat'))
			document.getElementById('tidio-chat').style.display='none';

			if(this.lightbox){
			this.$bvModal.show('modal-lightbox-home');			
			}
		},
		data(){
			return{
				projects: this.$store.state.projects,
				lightbox: true,
				link_: 'https://oportunidades.inmobiliariabi.cl/',
				src: require('@/assets/popup/LIGHTBOX_CYBER_BI_800X800_4.jpg')
			}
		},
		methods: {
			goTo(url, params){
				this.$router.push({ name: url, params: params }).catch(err => { console.log('ERROR:',err) });
			},
			scrollToElem(elemName) {
				window.scroll({
					top: document.querySelector(elemName).offsetTop,
					behavior: 'smooth'
				});
			},
			openLink(url){				
				//console.log(url);
				window.open(url);
			}
		},
		watch: {
			'$store.state.projects': {
				handler: function()  {
					this.projects = this.$store.getters.getProjects;
					if(this.scrollTo){
						this.scrollToElem(this.scrollTo);
					}
				}
			}
		}
	}
</script>

<style>
	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
	.subtitle-type {
		font-size: 2rem;
		line-height: 2rem;
		color: #6f6f6f;
		font-weight: bold;
	}
	.subtitle {
		font-size: 3rem;
		line-height: 3rem;
		color: #6f6f6f;
	}
	.subtitle-location {
		font-size: 1rem;
		line-height: 1rem;
		color: #b12525 !important;
		text-transform: uppercase;
		font-weight: bold;
	}
	.text-red{
		color: #b12525 !important;
		text-transform: uppercase;
		font-weight: bold;
	}
	.proyect-elements .img-project{
		filter: grayscale(100%);
	}
	.proyect-elements:hover .img-project{
		filter: grayscale(0%);
	}
</style>
